export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const abs = (url) => `${process.env.REACT_APP_BACKEND_URL}${url}`;

export const STATUS = {
  new: { label: "Nová", cls: "bg-blue-500/15 text-blue-300 border-blue-500/30" },
  in_progress: { label: "Prebieha", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  completed: { label: "Dokončená", cls: "bg-green-500/15 text-green-300 border-green-500/30" },
  cancelled: { label: "Zrušená", cls: "bg-red-500/15 text-red-300 border-red-500/30" },
};
export const STATUS_ORDER = ["new", "in_progress", "completed", "cancelled"];

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleString("sk-SK", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const fmtDay = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleDateString("sk-SK", { day: "2-digit", month: "2-digit", year: "numeric" });
};

// yyyy-mm-dd for <input type=date>
export const toDateInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return d.toISOString().slice(0, 10);
};

// Deadline color: green >3 days, orange <=3 days, red overdue; archived/none => null
export const deadlineColor = (item) => {
  if (item.archived || !item.expected_completion_date) return null;
  const exp = new Date(`${toDateInput(item.expected_completion_date)}T23:59:59`);
  if (isNaN(exp)) return null;
  const days = (exp - new Date()) / 86400000;
  if (days < 0) return "red";
  if (days <= 3) return "orange";
  return "green";
};

export const DEADLINE_DOT = { green: "bg-green-500", orange: "bg-amber-500", red: "bg-red-500" };
export const DEADLINE_LABEL = { green: "V termíne", orange: "Blíži sa termín", red: "Termín prekročený" };

// Download an XLSX (or any blob) from an authed API GET
export const downloadXlsx = async (axios, url, params, token, filename) => {
  const res = await axios.get(url, {
    headers: { Authorization: `Bearer ${token}` },
    params,
    responseType: "blob",
  });
  const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
};

export const todayStr = () => new Date().toISOString().slice(0, 10);
